import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, AlertCircle } from 'lucide-react';
import config from '../../config';
import './index.css'; // Importing the specific CSS file

const Login = ({ onLogin, onBack }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Backend expects application/x-www-form-urlencoded
      const formData = new URLSearchParams();
      formData.append('username', email);
      formData.append('password', password);

      const response = await fetch(`${config.API_URL}/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || 'Invalid email or password');
      }

      const data = await response.json();
      
      // Store token
      localStorage.setItem('token', data.access_token);
      
      if (onLogin) onLogin();
      
      // Redirect to dashboard
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left Split - Branding & Testimonial (Hidden on Mobile) */}
      <div className="login-left">
        <div className="login-bg-overlay"></div>
        <div className="login-testimonial">
          <div className="quote-icon">“</div>
          <p className="quote-text">
            Financial freedom is available to those who learn about it and work for it. Nerus Group helped me achieve mine.
          </p>
          <div className="quote-author">— Sarah Jenkins, Investor</div>
        </div>
        <div style={{ position: 'relative', zIndex: 10, fontSize: '0.875rem', opacity: 0.7 }}>
          © {new Date().getFullYear()} Nerus Group.
        </div>
      </div>

      {/* Right Split - Login Form (Full width on Mobile) */}
      <div className="login-right">
        <div className="login-container">
          <div className="login-header">
            {/* Replace src with your actual logo path */}
            <img
              src="https://res.cloudinary.com/dvqwan8qc/image/upload/v1769418002/nerusfull_tdovvh.jpg"
              alt="Nerus Group"
              className="login-logo"
            />
            <h2 className="login-title">Welcome Back</h2>
            <p className="login-subtitle">Please enter your details to sign in.</p>
          </div>

          {error && (
            <div style={{ backgroundColor: '#fee2e2', color: '#ef4444', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <div className="form-input-wrapper">
                <Mail size={18} className="input-icon" />
                <input
                  type="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="form-input-wrapper">
                <Lock size={18} className="input-icon" />
                <input
                  type="password"
                  className="form-input"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            <div className="form-options">
              <label className="remember-me">
                <input type="checkbox" disabled={isLoading} /> Remember me
              </label>
              <a href="#" className="forgot-password">Forgot Password?</a>
            </div>

            <button type="submit" className="btn-full" disabled={isLoading}>
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <div className="divider">
            <span>Or continue with</span>
          </div>

          {/* <div className="social-login">
            <button className="btn-social">
              <span style={{fontWeight: 'bold', color: '#DB4437'}}>G</span> Google
            </button>
            <button className="btn-social">
              <span style={{fontWeight: 'bold', color: '#1877F2'}}>f</span> Facebook
            </button>
          </div> */}

          <div className="login-footer">
            Don't have an account? <a href="#" className="login-link">Sign up</a>
            <br />
            {onBack && (
              <button
                onClick={onBack}
                style={{ marginTop: '1rem', background: 'none', border: 'none', color: '#64748b', fontSize: '0.8rem', cursor: 'pointer' }}
              >
                ← Back to Home
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;